import { useMemo, useState } from 'react'
import {
  UseDisclosurePropTypes,
  UseDisclosureTypes
} from './useDisclosure.types'

export const useDisclosure = (
  props?: UseDisclosurePropTypes
): UseDisclosureTypes => {
  const [isOpen, setIsOpen] = useState(props?.defaultIsOpen || false)

  const onClose = () => {
    setIsOpen(false)
  }

  const onOpen = () => {
    setIsOpen(true)
  }

  const onToggle = () => {
    setIsOpen((isOpenState) => !isOpenState)
  }

  return useMemo(
    () => ({
      isOpen,
      onClose,
      onOpen,
      onToggle
    }),
    [isOpen]
  )
}
